export const mockTransactionReportSummaryGet = (body, params, options) => {
  const { guid = '' } = options || {};
  return {
    [guid]: {
      authorizationCount: 30,
      authorizationVolume: 51870.0,
      settlementCount: 30,
      settlementVolume: 51870.0,
      chargebackCount: 30,
      chargebackVolume: 51870.0,
      chargebackRatio: 100.0
    }
  };
};

export default mockTransactionReportSummaryGet;
